import React, { useEffect, useState } from 'react';

const JobList = () => {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    fetch('https://apigw.solides.com.br/jobs/v3/home/vacancy?take=6&slug=distribuidorayork&page=1')
      .then(res => res.json())
      .then(data => {
        const items = data.data.data;
        setJobs(items);
      });
  }, []);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mx-2 w-full">
      {jobs.map(job => (
        <VacancyCard key={job.id}
          title={job.title}
          jobType={job.jobType}
          id={job.id}
          publishedAt={job.createdAt}
          city={job.city ? job.city.name : null}
          uf={job.state ? job.state.code : null}
          country={job.address.country ? job.address.country.name : null}
          pcd={job.peopleWithDisabilities}
          seniority={job.seniority}
        />
      ))}
    </div>
  );
};

export default JobList;

function VacancyCard({ id, title, jobType, publishedAt, city, uf, pcd, seniority, country }) {
  const postDate = new Date(publishedAt);
  const now = new Date();
  const diffDays = Math.floor((now - postDate) / (1000 * 60 * 60 * 24));


  const Tag = ({ value }) => {
    return (
      <div className="flex flex-wrap gap-2">
        <div
          className="px-2 text-xs space-x-2 font-normal rounded-md inline-flex items-center py-1 bg-blue-100 capitalize">
          <div className="break-inside-avoid font-body s-text text-caption font-regular ">
            {value}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-lg w-full flex flex-col gap-3 p-4 border shadow-sm relative my-1">
      <p className="leading-5 text-subtitle2 line-clamp-2">
        <a title="Controlador de Pátio | Piripiri - PI" href="/vaga/611885">
          {title}
        </a>
      </p>
      <div className="flex flex-wrap items-start gap-x-4 gap-y-2 text-gray-900">
        <p className="flex items-center gap-x-[3px] text-gray-900 text-sm">
          {city !== null ?
            <div>
              <i className='bi bi-geo-alt-fill' /> {city} - {uf}
            </div>
            :
            <div>
              <i className='bi bi-geo-alt-fill' /> {country}
            </div>
          }
        </p>
        {pcd === true &&
          <p className="flex items-center gap-x-1 text-gray-900 text-sm">
            <i className="bi bi-person-arms-up" />
            Elegível PCD
          </p>
        }
      </div>
      <div className='d-flex gap-1'>
        <Tag value={jobType} />
        {seniority.length > 0 &&
          <Tag value={seniority[0].name} />
        }

      </div>
      <div className="text-caption text-sm text-gray-600">
        {diffDays === 0 && 'Postada hoje'}
        {diffDays === 1 && 'Postada ontem'}
        {diffDays > 1 && `Postada há ${diffDays} dias`}
      </div>

      <span className="mt-auto">
        <a className="s-button flex justify-center px-10 py-1.5 font-bold relative text-[13px] sm:text-[14px] rounded-lg hover:bg-opacity-85 disabled:text-state-disabled/[0.8] disabled:bg-state-disabled-background/[0.24] disabled:cursor-not-allowed transition duration-300 ease-in-out bg-[#b51a3d] text-[#fff] mt-1.5"
          href={'https://distribuidorayork.vagas.solides.com.br/vaga/' + id} target='_blank'>
          Ver Vaga
        </a>
      </span>
    </div>
  )
}

